import { styled, Typography } from '@ori-ui/mui';
import type { FC } from 'react';
import { memo } from 'react';

import { ShadeElement } from './ShadeElement';
import type { TestIdProp } from '~/models';

interface ShadeProps extends TestIdProp {
  colorHexCode: string | null;
  colorImageSrc: string | null;
  colorName: string;
}

const Root = styled('div')(({ theme }) => ({
  color: theme.palette.grey.A400,
  display: 'flex',
  alignItems: 'center',
}));

export const Shade: FC<ShadeProps> = memo(
  ({ 'data-testid': testId, colorHexCode, colorImageSrc, colorName }) => (
    <Root data-testid={testId}>
      <ShadeElement
        colorHexCode={colorHexCode}
        colorImageSrc={colorImageSrc}
      />
      <Typography variant="caption">{colorName}</Typography>
    </Root>
  ),
);
